import { merge, mean, max, min } from 'ramda/es';
import * as moment from 'moment';
const defaultOptions = data => ({
  title: {
    // text: 'Vues',
  },
  tooltip: {
    trigger: 'axis'
  },
  xAxis: {
    type: 'category',
    boundaryGap: true,
    data: data.map(item => item.name)
  },
  yAxis: {
    type: 'value',
    axisLabel: {
      formatter: '{value}'
    }
  },
  dataZoom: {
    show: true,
    realtime: true,
    start: 0,
    end: 100
  },
  series: [
    {
      name: 'vues',
      type: 'line',
      data: data.map(item => item.value),
      markPoint: {
        data: [
          {
            type: 'max',
            name: max(data.map(item => item.value))
          },
          {
            type: 'min',
            name: min(data.map(item => item.value))
          }
        ]
      },
      markLine: {
        data: [
          {
            type: 'average',
            name: mean(data.map(item => item.value))
          }
        ]
      }
    }
  ]
});
export function createLineChart(data: any, options: string) {
  const chart = merge(defaultOptions(data), options);
  return chart;
}



// WEBPACK FOOTER //
// ./src/app/modules/stats/charts/line/lineCharts.ts